import React, { useEffect, useState } from "react";
import { Check, Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminReviews() {
  const [reviews, setReviews] = useState([]);
  const load = () => api.get("/reviews?approved_only=false").then((r) => setReviews(r.data));
  useEffect(() => { load(); }, []);
  const approve = async (id) => { await api.put(`/reviews/${id}/approve`); toast.success("Approved"); load(); };
  const remove = async (id) => { await api.delete(`/reviews/${id}`); load(); };
  return (
    <div>
      <h1 className="font-serif-display text-4xl mb-8">Reviews</h1>
      <div className="space-y-3">
        {reviews.map((r) => (
          <div key={r.id} className="bg-white border border-brand-border rounded-sm p-5 flex justify-between gap-4" data-testid={`admin-review-${r.id}`}>
            <div>
              <div className="text-brand-pink text-sm">{"★".repeat(r.rating)}{!r.approved && <span className="ml-2 text-xs bg-amber-100 text-amber-800 px-2 py-0.5 rounded-sm">Pending</span>}</div>
              <h4 className="font-serif-display text-lg mt-1">{r.title}</h4>
              <p className="text-sm text-muted-foreground">{r.body}</p>
              <p className="text-xs uppercase tracking-luxe mt-1">— {r.author}</p>
            </div>
            <div className="flex gap-2 h-fit">
              {!r.approved && <button onClick={() => approve(r.id)} className="bg-brand-ink text-white px-3 py-1.5 rounded-sm text-xs flex items-center gap-1 hover:bg-brand-pink hover:text-brand-ink transition-colors" data-testid={`approve-review-${r.id}`}><Check className="w-3 h-3" /> Approve</button>}
              <button onClick={() => remove(r.id)} className="text-destructive p-1.5"><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
        {reviews.length === 0 && <p className="text-sm text-muted-foreground">No reviews yet.</p>}
      </div>
    </div>
  );
}
